import classNames from "classnames";

export type TextButtonVariant = "link" | "subtle";

const variantClasses: Record<TextButtonVariant, string> = {
  link: "text-primary underline-offset-2 hover:underline",
  subtle: "text-text-muted hover:text-text-main",
};

/**
 * As classes do `TextButton`, para quem precisa da MESMA aparência num
 * elemento que não é `<button>`.
 *
 * ⚠️ Existe porque destino de NAVEGAÇÃO tem de ser `<Link>` — só a âncora
 * sobrevive a clique do meio e "abrir em nova aba" —, e transcrever os tokens
 * no call site é como duas peças do mesmo desenho divergem. Use isto, não uma
 * cópia: o "Ver todas" da vitrine de listas na Busca é o primeiro consumidor.
 *
 * ⚠️ Mora em arquivo PRÓPRIO, e não ao lado do componente, porque exportar
 * função de um arquivo de componente quebra o fast refresh — e o
 * `eslint.config.js` proíbe nominalmente somar arquivo novo à allowlist
 * daquela regra ("código novo separa componente de helper desde o início").
 */
export function textButtonClasses(variant: TextButtonVariant = "link", className?: string) {
  return classNames(
    "inline-flex items-center gap-1 font-body text-sm font-semibold",
    "transition-colors duration-150 active:opacity-70",
    "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 rounded",
    "disabled:opacity-40 disabled:cursor-not-allowed",
    variantClasses[variant],
    className,
  );
}
